/* CmdbSyncStatusRenderer.js */

"use strict";

const _ = require("lodash");

class CmdbSyncStatusRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("cmdb-sync-status-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on(
            "CmdbSyncStatus",
            (this._onCmdbSyncStatusColumn = this._onCmdbSyncStatusColumn.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeAllListeners("CmdbSyncStatus");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setCmdbSyncStatusColumn(this._model.getValue());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onCmdbSyncStatusColumn(newVal) {
        this._setCmdbSyncStatusColumn(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setCmdbSyncStatusColumn(newVal) {
        if (!_.isNil(newVal)) {
            this._rootElem.innerHTML = _.get(this._model._cmdbSyncStatus, newVal, "");
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = CmdbSyncStatusRenderer;
